// The callback's business belongs to the server-side OAuth attempt. Never replace it
// with the current business selection, including on reload or a route remount.
export const SP_CLAIM_KEY = 'sp_oauth_session';
export const SP_CLAIM_CONTEXT_KEY = 'sp_oauth_claim_context';

export const spClaimBusinessId = (value) => {
  if (!['string', 'number'].includes(typeof value) || !/^\d+$/.test(String(value))) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export function readSpClaimContext(claimToken) {
  try {
    const stored = JSON.parse(sessionStorage.getItem(SP_CLAIM_CONTEXT_KEY) || 'null');
    if (
      !claimToken ||
      sessionStorage.getItem(SP_CLAIM_KEY) !== claimToken ||
      stored?.claimToken !== claimToken
    )
      return null;
    const businessProfileId = spClaimBusinessId(stored.businessProfileId);
    return businessProfileId ? { claimToken, businessProfileId } : null;
  } catch {
    return null;
  }
}

export function captureSpClaimContext(claimToken, businessId) {
  if (typeof claimToken !== 'string' || !claimToken) return null;
  try {
    const existing = readSpClaimContext(claimToken);
    sessionStorage.setItem(SP_CLAIM_KEY, claimToken);
    // A later URL/global selection cannot retarget this token's recorded attempt.
    if (existing) return existing;
    const businessProfileId = spClaimBusinessId(businessId);
    sessionStorage.removeItem(SP_CLAIM_CONTEXT_KEY);
    if (!businessProfileId) return null;
    const context = { claimToken, businessProfileId };
    sessionStorage.setItem(SP_CLAIM_CONTEXT_KEY, JSON.stringify(context));
    return readSpClaimContext(claimToken);
  } catch {
    return null;
  }
}

export function clearSpClaimContext(claimToken) {
  try {
    // A late response from an old component must never erase a newer attempt.
    if (sessionStorage.getItem(SP_CLAIM_KEY) !== claimToken) return;
    sessionStorage.removeItem(SP_CLAIM_KEY);
    sessionStorage.removeItem(SP_CLAIM_CONTEXT_KEY);
  } catch {
    // The mounted page still discards its in-memory token.
  }
}

export function readSpClaimToken() {
  try {
    return sessionStorage.getItem(SP_CLAIM_KEY);
  } catch {
    return null;
  }
}
